import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

export interface LoggedInCallback {
    isLoggedIn(message: string, loggedIn: boolean , code : string , role : string): void;
}

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

    
    constructor(private http: HttpClient) { }

    login(username: string, password: string, tenantName : string  , callback : LoggedInCallback) {

        return this.http.post<any>(environment.APIENDPOINT + '/login', { "username": username, "password": password , "tenantName": tenantName }, this.setHeaders(tenantName))
            .pipe(map((user: any) => {
                if (user && user.jWTUser && user.jWTUser.token) {
                    
                    localStorage.setItem('currentUser', JSON.stringify(user.jWTUser));
                    localStorage.setItem('userTenant', tenantName);
                    localStorage.setItem('uid', user.jWTUser.id);
                    localStorage.setItem('fname', user.jWTUser.firstname);
                    localStorage.setItem('lname', user.jWTUser.lastname != null ? user.jWTUser.lastname : '' );
                    localStorage.setItem('email', user.jWTUser.email);
                    localStorage.setItem('role', user.jWTUser.userRole);
                    localStorage.setItem('stcode', user.jWTUser.statusCode);

                    if (typeof document !== 'undefined') {
                        document.cookie = `currentUser=${encodeURIComponent(JSON.stringify(user.jWTUser))}; path=/`;
                        document.cookie = `stcode=${user.jWTUser.statusCode}; path=/`;
                        document.cookie = `role=${user.jWTUser.userRole}; path=/`;
                    }
                
                    callback.isLoggedIn("user successfully logged in", true , user.jWTUser.statusCode , user.jWTUser.userRole);
                }else{
                    callback.isLoggedIn("user not logged in", false , "" ,"");
                    this.logout();
                }
            }));
    }


    activateAccount(username: string, temppassword: string, newpassword: string){
        return this.http.post(environment.APIENDPOINT + "/users/"+ username +"/active", { "newPassword": newpassword, "oldPassword": temppassword , "userName": username}, this.setAuthHeaders());
    }


    logout() {
        localStorage.removeItem('currentUser');
        localStorage.removeItem('userTenant');
        localStorage.removeItem('uid');
        localStorage.removeItem('fname');
        localStorage.removeItem('lname');
        localStorage.removeItem('email'); 
        localStorage.removeItem('role'); 
        localStorage.removeItem('stcode');     

        if (typeof document !== 'undefined') {
            document.cookie = "currentUser=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            document.cookie = "stcode=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            document.cookie = "role=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        }
    }


        private setHeaders( tenantName : string) {
            let headers = new HttpHeaders({
                'Content-Type': 'application/json',
                'X-Tenant': tenantName
            });
            return { headers: headers };
        }

        private setAuthHeaders() {
            let currentUser = JSON.parse(localStorage.getItem('currentUser'));
            let userTenant = localStorage.getItem('userTenant');
            if (currentUser && currentUser.token) {
                let headers = new HttpHeaders({
                    'Authorization': 'Bearer ' + currentUser.token,
                    'X-Tenant': userTenant,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                });
                return { headers: headers };
            }
        }
}
